// extracted by mini-css-extract-plugin
export var entityChip = "_s6-0";
export var entityChipMissing = "_s6-1";